var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "none",
    height: "none",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.450195 8.32678C0.450195 4.557 3.48931 1.5 7.24436 1.5C9.13783 1.5 10.8449 2.27936 12.0713 3.53293C13.3003 2.279 15.0139 1.5 16.8976 1.5C20.6527 1.5 23.6918 4.557 23.6918 8.32678C23.6918 12.381 21.8114 15.584 19.5623 17.8883C17.3238 20.1819 14.6748 21.6352 12.9907 22.2108C12.7016 22.3121 12.3679 22.35 12.071 22.35C11.7741 22.35 11.4404 22.3121 11.1513 22.2108C9.46722 21.6352 6.8182 20.1819 4.57967 17.8883C2.33059 15.584 0.450195 12.381 0.450195 8.32678Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.df0b6fd3dbee3ea104c2301ecca9e721.svg";
export { ForwardRef as ReactComponent };